module.exports = __webpack_public_path__ + "static/assets/71e18caa5aa8dbdbf4c9964298d4a0fd.png";